import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { fetchInteractions } from 'actions/messages';

export class FeedMessageControls extends Component {
  handleRefresh = () => {
    const { dispatch } = this.props;
    dispatch(fetchInteractions());
  }

  render = () => (
    <div>
      <button
        className="button--link button--link-inverse"
        onClick={this.handleRefresh}
        type="button"
        style={{ marginRight: '2rem' }}
      >
        <i className="fa fa-refresh" />
      </button>
      <Link className="link--inverse" to="/account">
        <i className="fa fa-cog" />
        <span className="u-visually-hidden">
          Settings
        </span>
      </Link>
    </div>
  )
}

FeedMessageControls.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(FeedMessageControls);